import type { IconSvgObject } from './types';

const Crown02Icon: IconSvgObject = [
  ["path", { d: "M5 20.5H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 12.5C6.89543 12.5 6 11.6046 6 10.5C6 10.308 6.02706 10.1223 6.07757 9.94654L2 7.5L5 17.5H19L22 7.5L17.9224 9.94654C17.9729 10.1223 18 10.308 18 10.5C18 11.6046 17.1046 12.5 16 12.5C14.8954 12.5 14 11.6046 14 10.5C14 9.8785 14.2835 9.32322 14.7282 8.95639L12 3.5L9.27181 8.95639C9.71652 9.32322 10 9.8785 10 10.5C10 11.6046 9.10457 12.5 8 12.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Crown02Icon;
